/** @module guildInputs */

function deleteCookies(cookies) {
    if (cookies) {
        cookies.forEach((cookie) => {
            document.cookie = cookie + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        });
    }
}

function getGuildCookies() {
    let cookiesToClear = [];

    if (document.cookie) {
        const cookies = document.cookie.split(';');

        cookies.forEach((cookie) => {
            cookie.split('=').forEach((cookieName) => {
                const regExp = new RegExp(/^spwk-guild_\w+/, 'g');

                // clear blanks
                cookieName = cookieName.replace(' ', '');
                if (cookieName.search(regExp) === 0) {
                    cookiesToClear.push(cookieName);
                }
            });
        });
    }

    return cookiesToClear;
}
/**
 * Set cookie for selected input.
 * Should not be referenced directly.
 *
 * @private
 * @see {@link guildInputs}
 */
export async function initGuildInputs(forms) {
    const cookieBaseName = 'spwk-guild_';

    forms.forEach((form) => {
        form.addEventListener('submit', () => {
            const formData = new FormData(form),
                entries = Object.fromEntries(formData).guild,
                cookieData = entries.split(','),
                cookieName = `${cookieBaseName}${cookieData[0]}`,
                cookieValue = cookieData[1],
                cookieExpirationDays = 30,
                cookieMaxAge = 60 * 60 * 24 * cookieExpirationDays;

            // delete all current guild cookies before setting new one
            deleteCookies(getGuildCookies());

            document.cookie = `${cookieName}=${cookieValue}; path=/; max-age=${cookieMaxAge};SameSite=Strict; Secure`;
        });
    });
}
